export function getCatSubjectDomains(state) {
  return state.catSubjectDomains || {};
}

export function getCatStats(state) {
  return state.catStats;
}

export function getSubjectDomainPosition(state) {
  return state.catSubjectDomainsPosition;
}



// WEBPACK FOOTER //
// ./src/app/cat-domain/store/getters.js